<template>

    <v-dialog
      v-model="$store.state.displayCSV"
      width="500"
      scrollable
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          color="black"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon small>mdi-information-outline</v-icon>
        </v-btn>
      </template>
    <v-card>
         <v-toolbar
      dense
      flat
    >
      <v-toolbar-title></v-toolbar-title>
        
        <v-spacer></v-spacer>
           <v-btn
            icon
           @click="closeDisplay()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
   
    </v-toolbar>
        <v-card-title>CSV-Download</v-card-title>
        <v-card-text>
            <p>Die Spaltennamen der heruntergeladenen Tabelle sind im Gegensatz zu den in SpruchList angezeigten Namen verkürzt.</p>
            <p><b>Zum Format</b></p>
            <p>CSV steht für "Comma-separated values" und bezeichnet ein einfaches Tabellenformat. CSV-Dateien lassen sich in einem beliebigen Text-Editor (z.B. Notepad++) öffnen und bearbeiten. CSV-Daten können auch leicht in ein Tabellenkalkulationsprogramm wie Excel oder OpenOffice Calc importiert werden.</p> 
            <p><b>Import in Excel:</b></p>
            <p>
            <ul>
                <li>Eine leere Excel-Arbeitsmappe öffnen.</li>
                <li>Im Reiter <b>Daten</b> auf <b>Externe Daten abrufen</b> und dann auf <b>Aus Text</b> anklicken.</li>
                <li>Heruntergeladene CSV-Datei auswählen.</li>
                <li>Ein Dialog zum Importieren der Datei öffnet sich. <b>Dateiursprung: Unicode (UTF-8)</b> und <b>Trennzeichen: Komma</b> auswählen. Die restlichen Optionen können einfach mit <b>Weiter</b> bestätigt werden. Am Ende auf <b>Fertig stellen</b> klicken.</li>
                <li>Im letzten Fenster den Import nochmal bestätigen.</li>
            </ul>
            </p>
            <p><b>Import in OpenOffice Calc:</b></p>
            <ul>
                <li>Im Reiter <b>Datei</b> den Menüpunkt <b>Öffnen...</b> anklicken und die heruntergeladene CSV-Datei auswählen.</li>
                <li>Ein Dialog zum Importieren der Datei öffnet sich. <b>Zeichensatz: Unicode (UTF-8)</b> und <b>Trennzeichen: Komma</b> auswählen und den Import bestätigen.</li>
            </ul>

        </v-card-text>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="closeDisplay()"
          >
            Schließen
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>


</template>
<script>

  export default {
    name: 'About',
    data: () => ({
        displayAbout: false
    }),
    methods:{
       closeDisplay() {
            this.$store.commit('setDisplayCSV', false);
        },
    }
  }
  </script>